export default "__VITE_ASSET__0018af3a__"